<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">

        <Modal
            :text="$t('product.notRestored')"
            id="modal_show_alert"
        />

        <div class="container">
            <SearchCollapse class="pt-4" :is-bg-white="true" :do-action="showCheckboxes">
                <div class="grid grid-cols-10 gap-3">
                    <div class="col-span-10 md:col-span-8 position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-8 ml-2">
                            {{ $t('product.name') }}
                        </div>
                        <b-form-input
                            v-model="search.productName"
                            class="focus:ring-0 border-gray-300"
                            @keyup.enter="searchDeletedProducts"
                        >
                        </b-form-input>
                    </div>

                    <div class="col-span-10 md:col-span-2">
                        <button class="bg-main border-0 hover:bg-hoverMain rounded-l h-9 w-50 focus:outline-none">
                            <img src="/images/search1.png" alt="" class="h-6 cursor-pointer" @click="searchDeletedProducts">
                        </button>
                        <button class="bg-main border-0 hover:bg-hoverMain rounded-r h-9 w-50 focus:outline-none">
                            <img src="/images/eraser%20(2).png" alt="" class="h-6 cursor-pointer" @click="resetDeletedProductsInfo">
                        </button>
                    </div>
                </div>
            </SearchCollapse>
        </div>

        <RowColumn class="mx-1.5">
            <TableTag
                class="w-full"
                getter-name="getDeletedProducts"
                fetch-getter-name="fetchDeletedProducts"
                :headers="headers"
                :body-properties="bodyProperties"
                :isSelectable=true
            >
                <template v-slot:custom="row">
                    <span>
                        {{ row.item.name }}
                    </span>
                </template>

                <template v-slot:checkboxes="row" v-if="canDeleteSaleHistory()">
                    <b-form-checkbox
                        v-if="isShowCheckbox"
                        size="lg"
                        :value=row.item.id
                        v-model="selectedProducts"
                    />
                </template>
                <template v-slot:checkAll_0 v-if="canDeleteSaleHistory()">
                    <b-form-checkbox
                        v-if="isShowCheckbox"
                        size="lg"
                        @change="selectAll"
                        v-model="isSelectedAll"
                    />
                </template>
            </TableTag>
            <div v-if="getDeletedProducts.length === 0" class="col-12">{{ $t('noData') }}</div>
            <div class="container mt-4">
                <b-button
                    variant="success"
                    v-if="selectedProducts.length > 0"
                    class="float-right"
                    @click="showRestoreModal">
                    {{ $t('product.restore') }}
                </b-button>

            </div>
        </RowColumn>
        <div class="row">
            <div class="col mt-2 ml-4">
                <Pagination
                    :search="search"
                    base-url="products/deleted"
                    :total-items="getDeletedProductsTotalCount"
                    method-name="searchDeletedProduct"
                />
            </div>
        </div>

        <b-modal id="restore-modal" hide-footer>
            <!-- Modal body -->
            <div class="modal-body">
                {{ $t('product.restoreWarning') }}
            </div>
            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal" @click="restore">{{
                        $t('yes')
                    }}
                </button>
                <button type="button" class="btn btn-primary" data-dismiss="modal" @click="cancel">{{ $t('no') }}
                </button>
            </div>
        </b-modal>
    </Row>

</template>

<script>
import currencyFormat from "../../mixin/currencyFormatMixin";
import Row from "../../components/html/Row";
import RowColumn from "../../components/RowColumn";
import TableTag from "../../components/html/TableTag";
import {mapGetters, mapActions} from "vuex";
import accessMixin from "../../mixin/accessMixin";
import SearchCollapse from "../../components/SearchCollapse";
import Pagination from "../../components/html/Pagination";
import Modal from "../../components/html/Modal";

export default {
    name: "ListDelete",
    components: {
        TableTag,
        RowColumn,
        Row,
        SearchCollapse,
        Pagination,
        Modal
    },
    mixins: [currencyFormat, accessMixin],
    data() {
        return {
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'trash'},
            ],
            search: {
                productName: '',
                page: 1
            },
            isShowCheckbox: false,
            selectedProducts: [],
            isSelectedAll: false,
            headers: [
                'id',
                'product.title',
                'sellingPrice'
            ],
            bodyProperties: [
                'id',
                'custom',
                'sellingPrice'
            ]
        }
    },
    computed: mapGetters([
        'getDeletedProductsTotalCount',
        'getDeletedProducts',
    ]),
    methods: {
        ...mapActions(['fetchDeletedProducts', 'searchDeletedProduct', 'pushProductRestore', 'setBreadcrumbItems']),
        sellingPrice(item) {
            return this.showCurrencyById(item.sellingPriceCurrency.id, item.sellingPrice)
        },
        restore() {
            this.$root.showOverlay = true
            this.$bvModal.hide('restore-modal')

            this.pushProductRestore(this.selectedProducts)
                .then((res) => {
                    this.searchDeletedProduct(this.search)
                        .then(() => {
                            if (res) {
                                this.selectedProducts = res
                                this.$bvModal.show('modal_show_alert')
                            }

                            this.isSelectedAll = false
                            this.$root.showOverlay = false
                            this.$root.showOverlay = false
                        })
                })
        },
        cancel() {
            this.$bvModal.hide('delete-sale-modal')
            this.selectedProducts = []
        },
        showRestoreModal() {
            if (this.selectedProducts.length > 0) {
                this.$bvModal.show('restore-modal')
            }
        },
        searchDeletedProducts() {
            this.$root.showOverlay = true
            this.searchDeletedProduct(this.search)
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    this.$root.showOverlay = false
                });
        },
        resetDeletedProductsInfo() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.searchDeletedProducts()
        },
        showCheckboxes() {
            if (this.isShowCheckbox) {
                this.headers.shift()
                this.bodyProperties.shift()
            } else {
                this.headers.unshift({name: ''})
                this.bodyProperties.unshift({
                    name: 'checkboxes',
                    bgWarning: this.isBgColorWarning,
                    bgDanger: this.isBgColorDanger
                })
            }

            this.isShowCheckbox = !this.isShowCheckbox

            if (this.selectedProducts.length > 0) {
                this.selectedProducts = []
                this.isSelectedAll = false
            }
        },
        selectAll() {
            this.isSelectedAll = !this.isSelectedAll

            if (this.isSelectedAll) {
                this.getDeletedProducts.map((item) => {
                    this.selectedProducts.push(item.id)
                })
            } else {
                this.selectedProducts = []
            }
        },
        isBgColorWarning(item) {
            item;
            return false
        },
        isBgColorDanger(item) {
            item;
            return false
        },
    },
    beforeCreate() {
        this.$store.dispatch('fetchCurrencies')
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
}
</script>

<style scoped>
.form-control {
    margin-bottom: 5px !important;
}

.mb-3 {
    margin-bottom: -16px !important;
}
</style>